import React from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
} from "react-share";
import Image from "next/image";
import facebookW from "@/public/icons/FacebookW.svg";
import telegram from "@/public/icons/telegramW.svg";
import linkedin from "@/public/icons/linkedinW.svg";
import twitter from "@/public/icons/twitterW.svg";
import share from "@/public/images/Forward.svg";
import heart from "@/public/images/heart.svg";
import redHeart from "@/public/icons/redHeart.svg";

interface Props {
  title: string;
  blog?: boolean;
  isFavorite?: boolean;
  handleRemoveToFavorites?: any;
  handleAddToFavorites?: any;
}

const index: React.FC<Props> = ({
  title,
  blog,
  isFavorite,
  handleRemoveToFavorites,
  handleAddToFavorites,
}) => {
  // Client Components are still rendered on the server. Referencing `window`
  // directly here made article and university detail pages return HTTP 500 to
  // crawlers before hydration could start.
  const shareUrl =
    typeof window === "undefined" ? "https://safiruni.com" : window.location.href;

  const handleShareClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: shareUrl,
        });
        console.log("Share was successful.");
      } catch (error) {
        console.error("Sharing failed", error);
      }
    } else {
      console.log("Web Share API is not supported in your browser.");
    }
  };

  return (
    <div
      // style={{ width: "" }}
      className="flex w-max items-center justify-end "
    >
      <div className="flex w-max items-center gap-2 ">
        {/* <FacebookShareButton url={shareUrl} title={title}>
          <Image src={facebookW} alt="facebookW" />
        </FacebookShareButton>
        <TelegramShareButton url={shareUrl} title={title}>
          <Image src={telegram} alt="telegram" />
        </TelegramShareButton>
        <LinkedinShareButton url={shareUrl} title={title}>
          <Image src={linkedin} alt="linkedin" />
        </LinkedinShareButton>
        <TwitterShareButton url={shareUrl} title={title}>
          <Image src={twitter} alt="twitter" />
        </TwitterShareButton> */}
        {!blog && (
          <button className="py-3 min-w-[30px] min-h-[30px] px-4 rounded-[10px] border ">
            {isFavorite ? (
              <Image
                onClick={handleRemoveToFavorites}
                src={redHeart}
                alt="redHeart"
              />
            ) : (
              <Image onClick={handleAddToFavorites} src={heart} alt="heart" />
            )}{" "}
          </button>
        )}

        <button
          className="bg-white py-3 px-4 min-w-[30px] min-h-[30px] rounded-[10px] border "
          onClick={handleShareClick}
        >
          <Image
            src={share}
            width={30}
            height={30}
            className="w-full h-full"
            alt="share"
          />
        </button>
      </div>
    </div>
  );
};

export default index;
